import { isEmpty, get, set, unset } from "lodash";

export function removeDraftFiles(properties, defaultValues, parent = []) {
	const keys = Object.keys(properties);
	keys.forEach((key) => {
		const currentKey = parent.concat(key);
		const property = get(properties, currentKey, {});
		const currentData = get(defaultValues, currentKey, {});

		if (property.inputType === "signature" && !isEmpty(currentData)) {
			return parseFile(defaultValues, currentKey, currentData);
		}

		if (property.inputType === "file" && !isEmpty(currentData)) {
			return parseFile(defaultValues, currentKey, currentData);
		}

		if (property.type === "array" && property.inputType === "fileList" && !isEmpty(currentData)) {
			const newFileList = parseFileList(currentData);
			return set(defaultValues, currentKey, newFileList);
		}

		if (property.type === "object") {
			return parseObject(currentData, property);
		}

		if (property.type === "array") {
			return parseArray(currentKey, currentData, property);
		}
	});

	return defaultValues;
}

function parseFile(defaultValues, currentKey, currentData) {
	if (!currentData.id) {
		unset(defaultValues, currentKey);
	}

	return currentData;
}

function parseFileList(currentData) {
	if (!currentData || !currentData.length) return currentData;

	return currentData.filter((file) => {
		if (file.id) return true;
		return false;
	});
}

function parseObject(currentData, property) {
	const properties = property.properties || {};
	return removeDraftFiles(properties, currentData);
}

function parseArray(currentKey, currentData, property) {
	const items = property.items || {};
	if (items.inputType === "file") return parseFile(currentData, currentKey, currentData);
	return removeDraftFiles(items, currentData);
}
